import { render, staticRenderFns } from "./CDADisponivelProtesto.vue?vue&type=template&id=22954314&"
import script from "./CDADisponivelProtesto.vue?vue&type=script&lang=js&"
export * from "./CDADisponivelProtesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports